// extracted by mini-css-extract-plugin
export default {"input":"Input_input__E5rzA","label":"Input_label__NXpCD","error":"Input_error__MApdY"};